<template>
  <v-card
    flat
    next
  >
    <v-card-title class="pb-0 pl-0 pr-0">
      <img
        src="../../../../public/google-drive.svg"
        width="25"
        height="25"
      >
      <p
        class="font-weight-medium ma-2"
      >
        Google Drive
      </p>
      <AddGoogleDriveLink
        @add="add"
      />
    </v-card-title>

    <v-card-text
      v-if="googleDriveFolders.length"
      class="pb-0"
    >
      <v-data-table
        :items="googleDriveFolders"
        :items-per-page="googleDriveFolders.length"
        dense
        hide-default-footer
        hide-default-header
      >
        <template v-slot:item="{ item }">
          <tr>
            <td
              style="height:36px"
            >
              <a
                :href="item"
                target="_blank"
              >
                {{ item }}</a>
            </td>
            <td class="text-right align-center pr-0">
              <v-btn
                icon
                class="mx-0"
                @click="remove(item)"
              >
                <v-icon color="grey">
                  delete_outline
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import AddGoogleDriveLink from "./AddGoogleDriveLink.vue";

export default {
  components: {
    AddGoogleDriveLink,
  },
  props: ["value"],
  data: () => ({
    googleDriveFolders: [],
    isChanged: false,
  }),
  watch: {
    value: {
      handler(val) {
        this.googleDriveFolders = val;
      },
      immediate: true,
    },
  },
  methods: {
    add(newLink){
      this.googleDriveFolders.unshift(newLink);
      this.isChanged = true;
    },
    remove(link) {
      const index = this.googleDriveFolders.findIndex(item => item === link);
      this.googleDriveFolders.splice(index, 1);
      this.isChanged = true;
    },
  },
};
</script>
